module.exports = __webpack_public_path__ + "static/media/bg.0e365c4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/bg.mp3
// module id = 7TvQ
// module chunks = 1